import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ScrollProgress from "@/components/site/ScrollProgress";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";
import QuizEngine from "@/components/site/QuizEngine";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { organizationSchema, breadcrumbSchema, SITE_URL } from "@/lib/seo";

export default function Quiz() {
  useDocumentMeta({
    title: "Which Program Fits Me? — 30-Second Quiz | Integrated Wellness",
    description:
      "Answer four quick questions and get routed to the Integrated Wellness program that fits your goals — body transformation, metabolic, cognitive, hormone, performance or longevity.",
    image: `${SITE_URL}/og/quiz.png`,
    url: `${SITE_URL}/quiz`,
    schema: [
      organizationSchema(),
      breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Program Quiz", url: "/quiz" },
      ]),
    ],
  });

  return (
    <div data-testid="quiz-page" className="min-h-screen bg-background">
      <ScrollProgress />
      <Header />
      <main className="pt-28 md:pt-32 pb-20 md:pb-28">
        <section className="relative max-w-3xl mx-auto px-4 md:px-8">
          <div className="absolute inset-0 iw-grid-bg opacity-30 -z-10" aria-hidden="true" />
          <div className="text-center">
            <div className="iw-overline">Program Router</div>
            <h1 className="mt-4 font-display font-bold tracking-tight leading-[1.05] text-[clamp(2rem,4.8vw,3.5rem)] text-primary">
              Which program fits <em className="not-italic text-accent">you</em>?
            </h1>
            <p className="mt-5 text-lg md:text-xl text-foreground/75 leading-relaxed">
              Four questions. Thirty seconds. A data-matched starting point —
              reviewed by licensed clinicians once you enroll.
            </p>
          </div>
          <div className="mt-10 md:mt-12">
            <QuizEngine />
          </div>
          <p className="mt-6 text-center font-mono text-[0.62rem] uppercase tracking-[0.2em] text-foreground/45">
            No email required · Instant result
          </p>
        </section>
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
